import { MouseEvent, ReactElement, useState } from 'react';
import { TableInstance } from 'react-table';
import { CheckboxStatus } from '../../../../enums';
import { Checkbox, CheckboxProps } from '../../../Form';
import { TableRowDataType } from '../../types';

export type OptionValue = string | number;

export type ToggleFilterProps<TableRowData extends TableRowDataType> = Omit<
  CheckboxProps,
  'hideLabel' | 'hasError' | 'isSubcomponent' | 'statusCurrent' | 'statusInitial'
> & {
  tableInstance: TableInstance<TableRowData>;
  columnId: string;
  filterValue: OptionValue;
};

export function ToggleFilter<TableRowData extends TableRowDataType>({
  tableInstance,
  columnId,
  filterValue,
  onClick,
  ...checkboxProps
}: ToggleFilterProps<TableRowData>): ReactElement {
  const [checkboxStatus, setCheckboxStatus] = useState<CheckboxStatus>(CheckboxStatus.Unchecked);

  const handleClick = (e: MouseEvent<HTMLElement>): void => {
    const { setFilter } = tableInstance;

    if (checkboxStatus === CheckboxStatus.Unchecked) {
      setFilter(columnId, filterValue);
      setCheckboxStatus(CheckboxStatus.Checked);
    } else {
      setFilter(columnId, null);
      setCheckboxStatus(CheckboxStatus.Unchecked);
    }

    if (onClick) {
      onClick(e);
    }
  };

  return <Checkbox {...checkboxProps} onClick={handleClick} statusCurrent={checkboxStatus} />;
}

ToggleFilter.displayName = 'ToggleFilter';
